import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';

// ============================================================================
// Cliente del pase de Google Wallet. Toda la lógica y la firma viven en
// krispis-server (`src/api/Wallet/`): los certificados no pueden salir de ahí.
//
// Aquí solo se DISPARA el refresh, y siempre en fire-and-forget: la venta ya
// ocurrió y no se puede deshacer porque Google no contestara. Mismo criterio
// que el commit de inventario.
// ============================================================================

export default {
    /**
     * Manda a Google el saldo de puntos vigente del cliente. Si cambió, al
     * cliente le llega la notificación ("tus puntos se actualizaron").
     *
     * **NUNCA lanza.** El server ya es idempotente y sabe distinguir los casos
     * que no son error: cliente sin pase, saldo sin cambios, wallet no
     * configurado. Un fallo aquí no debe teñir de rojo una venta que salió bien.
     */
    refreshPass: async (customerId?: string): Promise<void> => {
        if (!customerId) return;
        try {
            await axiosPrivate.post(`/wallet/refresh/${customerId}`);
        } catch (error) {
            // Solo se registra: el pase se pondrá al día en la próxima compra o
            // cuando el cliente abra su perfil.
            console.warn('No se pudo actualizar el pase de Google Wallet:', error);
        }
    }
};
